import { render } from "./instructor-open-tickets.vue?vue&type=template&id=dc2c2724"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__